import {Link} from '@app/dashboard/links/link';
import {AdHost} from '@common/admin/ads/ad-host';
import {ShareLinkButton} from '@app/dashboard/links/sharing/share-link-button';
import {Navbar} from '@common/ui/navigation/navbar/navbar';

// Extend local (sin tocar types globales todavía)
type LinkWithVisitConfig = Link & {
  visitConfig?: {
    adsEnabled?: boolean;
    tier?: string;
    reason?: string;
  };
  visit_config?: {
    adsEnabled?: boolean;
    ads_enabled?: boolean;
    tier?: string;
    reason?: string;
  };
};

interface LinkPageRendererProps {
  link: Link;
}

export function LinkIframeRenderer({link}: LinkPageRendererProps) {
  const l = link as LinkWithVisitConfig;

  const adsEnabledFromBackend =
    l.visitConfig?.adsEnabled ??
    l.visit_config?.adsEnabled ??
    l.visit_config?.ads_enabled ??
    undefined;

  // default: mantiene el comportamiento anterior (ads ON) si backend no manda nada
  const adsEnabled =
    typeof adsEnabledFromBackend === 'boolean' ? adsEnabledFromBackend : true;

  return (
    <div className="flex flex-col h-screen relative">
      <Navbar
        menuPosition="link-page-navbar"
        className="flex-shrink-0 sticky top-0"
        rightChildren={<ShareLinkButton link={link} />}
      />

      {adsEnabled ? <AdHost slot="frame" className="my-20" /> : null}

      <iframe src={link.long_url} className="flex-auto" />
    </div>
  );
}
